import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Work from "@/pages/Work";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

const PAGE_SEO = {
  "/": [
    "Inubaan Labs — Ideas Today. Impact Tomorrow.",
    "Inubaan Labs builds powerful web apps, mobile apps, cloud solutions and AI products that solve real problems and help businesses grow.",
  ],
  "/services": [
    "Services — Web, Mobile, Cloud & AI | Inubaan Labs",
    "Mobile apps, web development, AI & automation, cloud solutions, UI/UX design and digital solutions — one studio, end to end.",
  ],
  "/work": [
    "Our Work — PropertyARV, SkriptRush, SouqStream & More | Inubaan Labs",
    "Explore real products built by Inubaan Labs: PropertyARV, SkriptRush, SouqStream, Palace Of Flavor and more.",
  ],
  "/about": [
    "About Us — Inubaan Labs",
    "Inubaan Labs, founded by Jafar Rizvi, is a software and technology company turning ideas into practical, user-friendly digital products.",
  ],
  "/contact": [
    "Contact Us — Start a Project | Inubaan Labs",
    "Tell Inubaan Labs about your project — web apps, mobile apps, cloud or AI. We reply within 24 hours.",
  ],
};

const RouteSEO = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const [title, description] = PAGE_SEO[pathname] || PAGE_SEO["/"];
    document.title = title;
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute("content", description);
  }, [pathname]);
  return null;
};

const ScrollManager = ({ lenisRef }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    lenisRef.current?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname, lenisRef]);
  return null;
};

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-paper text-ink font-body">
      <BrowserRouter>
        <ScrollManager lenisRef={lenisRef} />
        <RouteSEO />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/work" element={<Work />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="bottom-right" theme="light" />
      </BrowserRouter>
    </div>
  );
}

export default App;
